// import React, { useState, useEffect } from "react";
// import "./sidebar.css";
// import { Routes, Link } from "react-router-dom";
// import { useDataLayerValue } from "../../DataLayer/DataLayer";
// import SidebarItem from "./SidebarItem";
// import { IoMdExit } from "react-icons/io";

// function Sidebar() {
//   const [{ sidebarOptions, userDetails, initialState, loggedIn }, dispatch] =
//     useDataLayerValue();
//   const [optionSelected, setOptionSelected] = useState(-1);
//   const [newSidebarOptions, setNewSidebarOptions] = useState([]);
//   const [sidebarCollapse, setSidebarCollapse] = useState(false);

//   const openSidebar = () => {
//     setSidebarCollapse(false);
//   };

//   return (
//     <>
//       {loggedIn && (
//         <div className={`sidebar ${sidebarCollapse && "sidebar-collapse"}`}>
//           <div className="sidebar-options">
// {sidebarOptions?.map(
//   (option, i) =>
//     option?.opFor.includes(userDetails?.userType) && (
//       <SidebarItem
//         key={i}
//         item={option}
//         sidebarCollapse={sidebarCollapse}
//         openSidebar={openSidebar}
//         userDetails={userDetails}
//       />
//     )
// )}
//           </div>
//           <div className="sidebar-collapser">
//             <IoMdExit
//               size={22}
//               style={{ minWidth: "22px" }}
//               className={`sidebar-collapser-icon ${
//                 sidebarCollapse && "sidebar-collapser-icon-toggle"
//               }`}
//               onClick={() => setSidebarCollapse(!sidebarCollapse)}
//             />
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default Sidebar;

import React, { useState, useEffect } from "react";
// import {ScrollView} from "react";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { Form, Stack, InputGroup } from 'react-bootstrap';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import MenuIcon from '@material-ui/icons/Menu';
import { IconButton } from "@material-ui/core";
import SearchIcon from '@material-ui/icons/Search';
import MenuItemSidebar from "./MenuItemSidebar";
import { sidebarOptions } from "../../DataLayer/reducer";
import { NavLink } from "react-router-dom";
import SidebarItem from "./SidebarItem";
import { IconContext } from "react-icons";
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Api from "../../Api/axios";
import { useNavigate } from "react-router-dom";



const Sidebar = ({ logout }) => {
	var toString = Object.prototype.toString;
	const navigate = useNavigate();
	function deepCopy(obj) {
		var rv;

		switch (typeof obj) {
			case "object":
				if (obj === null) {
					// null => null
					rv = null;
				} else {
					switch (toString.call(obj)) {
						case "[object Array]":
							// It's an array, create a new array with
							// deep copies of the entries
							rv = obj.map(deepCopy);
							break;
						case "[object Date]":
							// Clone the date
							rv = new Date(obj);
							break;
						case "[object RegExp]":
							// Clone the RegExp
							rv = new RegExp(obj);
							break;
						// ...probably a few others
						default:
							// Some other kind of object, deep-copy its
							// properties into a new object
							rv = Object.keys(obj).reduce(function (prev, key) {
								prev[key] = deepCopy(obj[key]);
								return prev;
							}, {});
							break;
					}
				}
				break;
			default:
				// It's a primitive, copy via assignment
				rv = obj;
				break;
		}
		return rv;
	}
	const [{ userDetails, initialState, loggedIn }, dispatch] = useDataLayerValue();
	const [userAvatar, setUserAvatar] = useState("");
	const [sideBarOpen, setSideBar] = useState(false);
	const [sideBarTempOpen, setSideBarTemp] = useState(false);
	const sideBarWidthOpen = "325px";
	const sideBarWidthClose = "50px";
	const userType = {
		'CENTRAL': 'Central',
		'DISTRICT': 'District',
		'SCHOOL_ADMIN': 'School Admin',
		'TEACHER': 'Teacher',
		'PARENT': 'Parent',
		'STUDENT': 'Student',
	}
	const [searchList, setSearchList] = useState(deepCopy(sidebarOptions));
	const EditSearchList = (newList) => {
		// console.log(newList)
		setSearchList(newList)
		// console.log("heya")
		// setSideBarOpen(sideBarOpen)
	}
	const setSideBarOpen = (toChange) => {
		setSideBar(toChange);
		if (!toChange) {
			setSideBarTemp(false);
		}
	}
	const setSideBarTempOpen = (toChange) => {
		setSideBarTemp(toChange);
	}
	const [searchString, setSearchString] = useState("");
	// {
	// console.log(sidebarOptions);
	// }
	const searchStringChange = (e) => {
		setSearchString(e);
		const searchFilter = (op) => {
			return op.map((option) => {
				if (option && option.opFor.includes(userDetails?.userType)) {
					if (option.name.toLowerCase().includes(e.toLowerCase())) {
						option.active = true;
						return option;
					}
					if (option.options) {
						if (searchFilter(option.options).filter(ele => { return ele !== null }).length > 0) {
							option.options = searchFilter(option.options);
							option.active = true;
							return option;
						}
					}
				}
				return null;
			})
		}
		if (e === "") {
			EditSearchList(deepCopy(sidebarOptions));
		} else {
			// console.log(useDataLayerValue());
			EditSearchList(searchFilter(deepCopy(sidebarOptions)));
		}
	}
	const [schoolDict, setSchoolDict] = useState({
		name: "Youth India E-School",
		logo: "data:image/jpeg;base64,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"
	});
	useEffect(() => {
		setUserAvatar(userDetails?.avatar ? userDetails?.avatar : `${process.env.PUBLIC_URL}/Images/default_avatar.jpg`)
	}, [userDetails])
	useEffect(() => {
		if (userDetails?.userType !== "CENTRAL" || userDetails?.userType !== "DISTRICT") {
			Api.get("/school-entity/school").then((res) => {
				setSchoolDict({ ...schoolDict, ...res.data });
			});
		}
	}, [userDetails?.userType]);
	if (loggedIn)
		return (
			<div
				style={{ width: sideBarOpen || sideBarTempOpen ? sideBarWidthOpen : sideBarWidthClose }}
			// onMouseEnter={e => {
			// 	setSideBarTempOpen(true)
			// }}
			// onMouseLeave={e => {
			// 	setSideBarTempOpen(false)
			// }}
			>
				<div className="pt-2 pb-2" style={{ width: sideBarOpen || sideBarTempOpen ? sideBarWidthOpen : sideBarWidthClose }}>
					{sideBarOpen || sideBarTempOpen ?
						<Stack className="ps-2" direction="horizontal">
							<Stack style={{ width: "98%" }} className="ps-2" direction="horizontal" gap={2}>
								<img
									src={schoolDict?.logo}
									height={"40px"}
									width={"40px"}
									style={{ borderRadius: "50%" }}
									alt="logo"
								/>
								<marquee direction="left">
									<p className="m-0 p-0 fw-bold" style={{ fontSize: "20px" }}> {schoolDict?.name}</p>
								</marquee>
							</Stack>
							{sideBarOpen ?
								<IconButton
									style={{ backgroundColor: "#FFF", color: "#000000" }}
									onClick={() => setSideBarOpen(false)}
								>
									<MenuOpenIcon style={{ fontSize: "30px" }} />
								</IconButton>
								:
								<IconButton
									style={{ backgroundColor: "#FFF", color: "#000000" }}
									onClick={() => setSideBarOpen(true)}
								>
									<MenuIcon style={{ fontSize: "30px" }} />
								</IconButton>
							}
						</Stack>
						:
						<center>
							<IconButton
								style={{ backgroundColor: "#FFF", color: "#000000", width: "100%" }}
								onClick={() => setSideBarOpen(true)}
							>
								<MenuIcon style={{ fontSize: "30px" }} />
							</IconButton>
						</center>
					}
				</div>
				<div style={{ width: sideBarOpen || sideBarTempOpen ? sideBarWidthOpen : sideBarWidthClose }}>
					{sideBarOpen || sideBarTempOpen ?
						<InputGroup className="p-2">
							<InputGroup.Text
								style={{ backgroundColor: "#F1F1F1", color: "#000000", border: "none" }}
							>
								<SearchIcon
									style={{ fontSize: "30px" }}
								/>
							</InputGroup.Text>
							<Form.Control
								type="text"
								placeholder="Search"
								value={searchString}
								onChange={(e) => searchStringChange(e.target.value)}
								style={{ backgroundColor: "#F1F1F1", color: "#000000", border: "none" }}
							/>
						</InputGroup>
						:
						<center>
							<IconButton
								style={{ backgroundColor: "#FFF", color: "#000000", width: "100%" }}
								onClick={() => setSideBarOpen(true)}
							>
								<SearchIcon style={{ fontSize: "30px" }} />
							</IconButton>
						</center>
					}
				</div>
				<hr className="m-0 p-0" />
				<div
					className="scrollable-div pb-4"
					style={{ width: sideBarOpen || sideBarTempOpen ? sideBarWidthOpen : sideBarWidthClose, overflowY: "scroll", overflowX: "hidden", height: "calc(100vh - 232px)", scrollbarWidth: "1px" }}
				>
					<MenuItemSidebar
						sidebarOptions={searchList}
						userDetails={userDetails}
						sideBarOpen={sideBarOpen}
						sideBarTempOpen={sideBarTempOpen}
						setSideBarOpen={setSideBarOpen}
						dispatch={dispatch}
						active={true}
						padding={35}
						EditSearchList={EditSearchList}
						recurList={[[searchList, 0]]}
					/>
				</div>
				<div className="pt-2 pb-2" style={{ position: "absolute", bottom: "0px", backgroundColor: "#f1f1f1", width: sideBarOpen || sideBarTempOpen ? sideBarWidthOpen : sideBarWidthClose }}>
					{sideBarOpen || sideBarTempOpen ?
						<Stack className="ps-2" direction="horizontal">
							<Stack style={{ width: "98%" }} direction="horizontal" gap={2}>
								<img
									// src="https://cdn.icon-icons.com/icons2/2643/PNG/512/male_boy_person_people_avatar_icon_159358.png"
									src={userAvatar}
									height={"40px"}
									width={"40px"}
									style={{ borderRadius: "50%" }}
									alt="logo"
								/>
								<div>
									<p className="m-0 p-0 fw-bold" onClick={(e) => navigate("/dashboard")}> {userDetails?.name ? userDetails?.name : "User"}</p>
									<p className="m-0 p-0 text-muted" style={{ fontSize: "12px" }}>{userDetails?.displayUserType ? userDetails.displayUserType : userDetails?.userType ? userType[userDetails?.userType] : "None"}</p>
								</div>
							</Stack>
							<div>
								<IconButton
									style={{ backgroundColor: "#f1f1f1", color: "#000000" }}
									onClick={() => {
										logout();
									}}
								>
									<ExitToAppIcon style={{ fontSize: "30px" }} />
								</IconButton>
							</div>
						</Stack>
						:
						<center>
							<img
								src={userAvatar}
								height={"40px"}
								width={"40px"}
								style={{ borderRadius: "50%" }}
								alt="logo"
							/>
						</center>
					}
				</div>
			</div>
		)
	else
		return (
			<>
			</>
		)
}

export default Sidebar;